var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useDispatch, useSelector } from "react-redux";
import { LoaderState } from "../../store/actions/loader.actions";
import { API_METHODS_ENUM } from "../../httpService";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { authenticateUser, fetchUser, getUser, logoutUser, requestAuthLink, resetUser } from "../../store/actions/response.actions";
import { getAccessToken, getRefreshToken, logout, } from "../../cookies";
import { useHistory, useLocation } from "react-router";
import querystring from "querystring";
import { useEmitter, useListener } from "../../helpers/customEvents";
import { setLoggedIn } from "../../store/actions";
import { useIntegrationName } from "../../helpers";
import { getResponseManager } from "../../responseManager/BeeResponseManager";
var authChangedEvent = "bee-auth-changed";
export var useFetchUser = function () {
    var dispatch = useDispatch();
    var hasCookies = useHasAuthCookie();
    // We need to listen to the login listener, this causes the component to update.
    useLoginListener(function () {
        dispatch(resetUser());
    });
    useEffect(function () {
        if (!hasCookies)
            return;
        dispatch(fetchUser());
    }, [hasCookies, dispatch]);
    return useSelector(function (state) {
        var _a;
        var userData = getUser(state.responseReducer);
        return (_a = getResponseManager(userData === null || userData === void 0 ? void 0 : userData.response).getData()) !== null && _a !== void 0 ? _a : null;
    });
};
export var useLoginListener = function (listener) {
    var hasCookie = useHasAuthCookie();
    var dispatch = useDispatch();
    var isAuthenticated = useSelector(function (state) { return !!state.globalReducer.isLoggedIn; });
    var reffedListener = useRef(listener);
    reffedListener.current = listener;
    useListener(authChangedEvent, useCallback(function (_a) {
        var _b;
        var hasLoggedIn = _a.detail;
        dispatch(setLoggedIn(hasLoggedIn));
        (_b = reffedListener.current) === null || _b === void 0 ? void 0 : _b.call(reffedListener, hasLoggedIn);
    }, [dispatch]));
    useEffect(function () {
        if (!hasCookie)
            return;
        if (isAuthenticated)
            return;
        dispatch(setLoggedIn(true));
    }, [hasCookie, isAuthenticated,]);
    return isAuthenticated;
};
export var useHasAuthCookie = function () {
    var name = useIntegrationName();
    return !!getAccessToken(name) || !!getRefreshToken(name);
};
export var useLogout = function () {
    var dispatch = useDispatch();
    var name = useIntegrationName();
    var onLogout = useEmitter(authChangedEvent);
    return useCallback(function () {
        dispatch(logoutUser());
        onLogout(false);
        logout(name);
    }, [dispatch, onLogout]);
};
export var useAuth = function () {
    var history = useHistory();
    var location = useLocation();
    var dispatch = useDispatch();
    var userAuthToken = useMemo(function () {
        var _a;
        var queryParams = querystring.parse((_a = location.search.substring(1)) !== null && _a !== void 0 ? _a : '');
        return [].concat(queryParams.ut || queryParams.loginIdentifier)[0];
    }, [location.search]);
    var isAuthenticating = useSelector(function (state) {
        return new LoaderState((state.loaderReducer), { keys: [
                API_METHODS_ENUM.AUTHENTICATE_USER,
                API_METHODS_ENUM.REQUEST_AUTHENTICATION_LINK
            ] }).isLoading() || !!userAuthToken;
    });
    var authenticate = useCallback(function (email) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, Promise.resolve(dispatch(requestAuthLink({ email: email }))).then(function (result) { return __awaiter(void 0, void 0, void 0, function () {
                    var r;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, Promise.resolve(result)];
                            case 1:
                                r = _a.sent();
                                return [2 /*return*/, r.data];
                        }
                    });
                }); })];
        });
    }); }, [dispatch]);
    var onAuthenticated = useEmitter(authChangedEvent);
    var isAuthenticated = useLoginListener();
    useEffect(function () {
        if (!userAuthToken)
            return;
        Promise.resolve(dispatch(authenticateUser({ loginToken: userAuthToken }))).then(function () {
            var _a;
            var params = querystring.parse((_a = location.search.substring(1)) !== null && _a !== void 0 ? _a : '');
            delete params.ut;
            delete params.loginIdentifier;
            history.replace({ search: querystring.stringify(params) });
            onAuthenticated(true);
        }).catch(function () {
            onAuthenticated(false);
        });
    }, [dispatch, userAuthToken, location.search]);
    return { isAuthenticated: isAuthenticated, authenticate: authenticate, isAuthenticating: isAuthenticating };
};
